import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

export interface AICredits {
  companyId: string;
  creditsTotal: number;
  planSubscriptionCreditsTotal: number;
  creditsRemaining: number;
  amountRemaining: number;
}

@Injectable({
  providedIn: 'root',
})
export class AICreditsApiService extends ApiService<any> {
  protected APIUrl = environment.SPRING_ENDPOINT_URL + this.getResourceUrl();

  constructor(
    protected httpClient: HttpClient,
    protected companyStateService: CompanyStateService,
  ) {
    super(httpClient);
  }
  override getResourceUrl(): string {
    return '/v2';
  }

  getAICredits(): Promise<{ item: AICredits }> {
    const params = new HttpParams().set(
      'companyId',
      this.companyStateService.getSelectedCompanyId(),
    );

    return firstValueFrom(
      this.requestAsObservable('', 'GET', 'credits/info', params),
    );
  }

  exportCreditsReport(): Promise<void> {
    const params = new HttpParams().set(
      'companyId',
      this.companyStateService.getSelectedCompanyId(),
    );
    return firstValueFrom(
      this.requestAsObservable('', 'GET', 'credits/export', params),
    );
  }
}
